import React from "react";
import { experience } from "./data";

function ExperienceTimeline() {
  return (
    <section className="ops-section" id="experience">
      <div className="section-heading">
        <p>Career Timeline</p>
        <h2>System log of growth and responsibility</h2>
      </div>
      <div className="timeline">
        {experience.map((entry) => (
          <article className="timeline-entry" key={`${entry.time}-${entry.role}`}>
            <time>[{entry.time}]</time>
            <div className="glass-panel">
              <span>{entry.range}</span>
              <h3>{entry.role}</h3>
              <p className="timeline-env">{entry.env}</p>
              <p>{entry.work}</p>
              <strong>Key win: {entry.wins}</strong>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ExperienceTimeline;
